<template>
    <div class="the-navbar__user-meta flex items-center" v-if="userInfo.fullName">

        <div class="text-right leading-tight hidden sm:block">
            <p class="font-semibold">{{ userInfo.fullName }}</p>
            <small class="font-semibold">{{ userInfo.username }}</small>
        </div>

        <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="con-img ml-3">
                <img v-if="!image" key="onlineImg" :src="userInfo.photoURL" alt="user-img" width="40" height="40"
                    class="rounded-full shadow-md cursor-pointer block" style="border: #FFC87BFF solid 2px;" />
                <img v-else key="onlineImg" :src="image" alt="user-img" width="40" height="40"
                    class="rounded-full shadow-md cursor-pointer block" style="border: #FFC87BFF solid 2px;" />
            </div>

            <vs-dropdown-menu class="vx-navbar-dropdown">
                <ul style="min-width: 11rem">

                    <li v-if="ShowHiddenProfileOption && userInfo.userRole === 'organization'"
                        class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                        @click="$router.push('/user/organization-info').catch(() => { })">
                        <feather-icon icon="UserIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Quản lí tổ chức</span>
                    </li>

                    <!--                    <vs-divider v-if="ShowHiddenProfileOption" class="m-1"/>-->

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="handlerRule"
                        v-if="!(userInfo.userRole === 'user')">
                        <feather-icon icon="LockIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Đổi mật khẩu</span>
                    </li>

                    <!--                    <vs-divider class="m-1" v-if="!(userInfo.userRole == 'user')"/>-->

                    <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="logout">
                        <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">Đăng xuất</span>
                    </li>
                </ul>
            </vs-dropdown-menu>
        </vs-dropdown>
    </div>
</template>

<script>
export default {
    data() {
        return {
            image: null,
            userInfo: {},
            ShowHiddenProfileOption: true,
        }
    },
    watch: {
        '$store.state.userInformation'(val) {
            if (!this.userInfo.id) {
                this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, val);
            }
        }
    },
    created() {
        this.userInfo = Object.assign({}, this.$store.state.AppActiveUser, JSON.parse(localStorage.getItem('userInfo')));
        if (this.userInfo.userRole === 'organization') this.userInfo.fullName = 'Quản trị tổ chức';
        if (this.userInfo.userRole === 'organization_branch') this.userInfo.fullName = 'organization_branch';
        this.ShowHiddenProfile()
        this.getInfo();
    },
    methods: {
        isPermission() {

        },
        getInfo: function () {
            if (this.userInfo.img && this.userInfo.img.includes('infocare')) {
                this.image = this.userInfo.img.replace('cdn.infocare', 'cdnimage.inviv')
            } else {
                this.image = this.userInfo.img;
            }
        },
        ShowHiddenProfile() {
            if (this.$router.currentRoute.meta.rule == 'admin') {
                this.ShowHiddenProfileOption = false
            }
        },
        handlerRule() {
            // if (this.$router.currentRoute.meta.rule == 'admin') {
            //     this.$router.push(`/admin/reset-password`).catch(() => {
            //     })
            // }
            // if (this.$router.currentRoute.meta.rule == 'organization') {
            //     this.$router.push(`/user/reset-password`).catch(() => {
            //     })
            // }
            this.$router.push(`/user/reset-password`).catch(() => {
            })
        },
        async logout() {
            const remember = localStorage.getItem('remember') === 'true';
            if (localStorage.getItem("deviceToken")) {
                await this.$crm.post('/notification/unsubscribe', { tokens: [localStorage.getItem("deviceToken")] }).then(() => {
                    this.$vs.loading.close();
                }).catch(() => {
                    this.$vs.loading.close();
                }).finally(() => {
                });
            }
            // localStorage.clear();
            if (remember) {
                const username = localStorage.getItem('username');
                const password = localStorage.getItem('password');
                localStorage.clear();
                localStorage.setItem('username', username);
                localStorage.setItem('password', password);
                localStorage.setItem('remember', 'true'); 
            } else {
                localStorage.clear();
            }
            return this.$router.push('/pages/login');
        },
    },
    mounted() {
        this.$eventBus.$on('update-avatar', () => {
            this.getInfo();
        })
    }
}
</script>

<style scoped>
.text-right {
    color: white;
}
</style>
